var _excluded = ["includeAuth", "headers"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { ApolloClient, createHttpLink, from, InMemoryCache } from '@apollo/client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { setContext } from '@apollo/client/link/context';
import { ToggledFeature } from '@domain-group/fe-allhomes-library';
import getSha256 from '../utils/sha256';
var getCache = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  return window.__APOLLO_STATE__ || {};
};
var sha256 = getSha256();
var buildLink = _ref => {
  var graphql = _ref.graphql,
    _ref$toggledFeatures = _ref.toggledFeatures,
    toggledFeatures = _ref$toggledFeatures === void 0 ? {} : _ref$toggledFeatures,
    token = _ref.token;
  var useAPQ = sha256 && !toggledFeatures[ToggledFeature.GRAPHQL_DISABLE_APQ.name];
  var authLink = setContext((_, _ref2) => {
    var includeAuth = _ref2.includeAuth,
      headers = _ref2.headers,
      context = _objectWithoutProperties(_ref2, _excluded);
    return _objectSpread(_objectSpread({}, context), {}, {
      headers: includeAuth ? _objectSpread(_objectSpread({}, headers), {}, {
        'x-myah-token': token
      }) : headers
    });
  });
  var httpLink = createHttpLink({
    uri: graphql,
    credentials: 'include'
  });
  return from([...(useAPQ ? [createPersistedQueryLink({
    sha256,
    useGETForHashedQueries: true
  })] : []), authLink, httpLink]);
};
var apolloClientFactory = _ref3 => {
  var graphql = _ref3.graphql,
    _ref3$isProduction = _ref3.isProduction,
    isProduction = _ref3$isProduction === void 0 ? false : _ref3$isProduction,
    _ref3$toggledFeatures = _ref3.toggledFeatures,
    toggledFeatures = _ref3$toggledFeatures === void 0 ? {} : _ref3$toggledFeatures,
    token = _ref3.token;
  return new ApolloClient({
    devtools: {
      enabled: !isProduction
    },
    link: buildLink({
      graphql,
      toggledFeatures,
      token
    }),
    clientAwareness: {
      name: 'fe-co-allhomes-api',
      version: '1.x'
    },
    cache: new InMemoryCache({
      typePolicies: {
        AutocompleteResult: {
          keyFields: ['id', 'type']
        }
      },
      possibleTypes: {
        Locality: ['Street', 'Division', 'District', 'Region', 'SchoolCatchment', 'Postcode'],
        ResearchLocality: ['Street', 'Division', 'District', 'Region']
      }
    }).restore(getCache())
  });
};
export default apolloClientFactory;